<template>
  <div class="left-chart-2" id="left-chart-2"></div>
</template>

<script>
import { querysbzcbhsr } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart2',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const echartsDom = document.getElementById('left-chart-2')
      const apiData = await querysbzcbhsr(this.date)
      let xDatas = []
      let cbDatas = []
      let srDatas = []
      apiData.forEach(item => {
        xDatas.push(item.assets_type || '其他')
        cbDatas.push(item.between_sbcb / 10000)
        srDatas.push(item.between_sbsr / 10000)
      })
      this.chart = this.$echarts.init(echartsDom)
      const options = {
        title: {
          text: '设备总成本和收入',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          right: '0',
          textStyle: {
            color: '#fff',
          },
          data: ['总收入', '总成本'],
        },
        grid: {
          top: 80,
          bottom: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#fff',
            },
            data: xDatas,
          },
        ],
        yAxis: {
          name: '单位：万元',
          nameTextStyle: {
            color: '#fff',
          },
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
          boundaryGap: [0, 0.01],
        },
        series: [
          {
            name: '总收入',
            type: 'bar',
            data: srDatas,
          },
          {
            name: '总成本',
            type: 'bar',
            data: cbDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-2 {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
}
</style>
